// src/main.js


// 🚀 自动跳转判断（必须在最顶部）
(function () {
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent);
  const pathname = window.location.pathname;

  if (isMobile && !pathname.startsWith('/m/')) {
    window.location.href = '/m/';
  } else if (!isMobile && pathname.startsWith('/m/')) {
    window.location.href = '/';
  }
})();




import 'core-js/stable'; // 引入 core-js 的稳定版本，以支持 ES6+ 特性
import 'regenerator-runtime/runtime'; // 引入 regenerator-runtime 以支持 async/await


import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store';

import ElementUI from 'element-ui'    // 引入 Element UI
import 'element-ui/lib/theme-chalk/index.css'  // 引入 Element UI 样式

import './assets/fontawesome/css/all.css'  // 引入 fontawesome iconfont 样式

import { xlog } from '@/utils/utils'; // 导入日志函数
Vue.prototype.$xlog = xlog; // 挂载到 Vue 原型
window.xlog = xlog; // 这样就可以在组件中直接使用


Vue.use(ElementUI)  // 全局注册 Element UI

Vue.config.productionTip = false

Vue.config.devtools = true; // 启用 Vue DevTools

// if (process.env.NODE_ENV === 'development') {
//   Vue.config.devtools = true;
// }


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
